import { marketBackend, marketRequest } from './marketRefresh'
import { stockQuoteKey } from './stockQuoteFeed'

async function request(kind, params = {}) {
  return marketRequest(kind, params)
}

export async function getHongKongTrades(code) {
  const result = await request('trades', { code })
  if (!result || result.code !== 0 || !Array.isArray(result.data && result.data.details)) throw new Error('分时成交返回异常')
  return result.data.details
}

export async function getHongKongIndustries(initial = false) {
  const rows = await marketBackend('stockGGHot', { plate: 400, rank: 1, include_quote: 1 }, 'post')
  if (!Array.isArray(rows)) throw new Error('港股行业返回异常')
  return rows.map(item => ({ bd_code: item.code, bd_name: item.prod_name, bd_zdf: item.px_change_rate, nzg_name: item.fn || '', nzg_zxj: item.nzg_zxj, nzg_zdf: item.fzdf, code: stockQuoteKey(item.fc, 'hk') }))
}

export async function getHongKongBoard(params) {
  const result = await marketRequest('board', params, true)
  if (!result || result.code !== 0 || !Array.isArray(result.data && result.data.rank_list)) throw new Error('港股板块行情返回异常')
  return { data: result.data.rank_list, total: Number(result.data.total || 0), current_page: Number(params.page || 1), per_page: Number(params.page_size || 20) }
}
